import {
  targetGroupsByRegionConstants,
  createTargetGroupsByRegionConstants,
  editTargetGroupsByRegionConstants,
  addTargetGroupsByRegionConstants,
  removeTargetGroupsByRegionConstants,
  deleteTargetGroupsByRegionConstants,
} from "../_redux-constants";
import { targetGroupsRegionService } from "../../_services";
import { errorExtractor } from "../../_helpers";

function getTargetGroupsByRegion(queryParams) {
  function getTargetGroupsByRegionLoad() {
    return {
      type: targetGroupsByRegionConstants.TARGET_GROUPS_BY_REGION_LOADING,
    };
  }
  function getTargetGroupsByRegionSuccess(data) {
    return {
      type: targetGroupsByRegionConstants.TARGET_GROUPS_BY_REGION_SUCCESS,
      data,
    };
  }
  function getTargetGroupsByRegionFailure(error) {
    return {
      type: targetGroupsByRegionConstants.TARGET_GROUPS_BY_REGION_FAILURE,
      error,
    };
  }
  // return (dispatch) => {
  //   dispatch(getTargetGroupsByRegionLoad());
  //   return targetGroupsRegionService.getTargetGroupsByRegion(queryParams).then(
  //     (data) => {
  //       dispatch(getTargetGroupsByRegionSuccess(data));
  //     },
  //     (error) => {
  //       dispatch(getTargetGroupsByRegionFailure(error?.toString()));
  //     }
  //   );
  // };
  return (dispatch) => {
    dispatch(getTargetGroupsByRegionLoad());
    return new Promise((resolve, reject) => {
      return targetGroupsRegionService
        .getTargetGroupsByRegion(queryParams)
        .then(
          (data) => {
            dispatch(getTargetGroupsByRegionSuccess(data));
            resolve(data);
          },
          (error) => {
            dispatch(getTargetGroupsByRegionFailure(error?.toString()));
            errorExtractor(error, reject);
          }
        );
    });
  };
}

function createTargetGroupsByRegion(requestBody) {
  function createTargetGroupsByRegionLoad() {
    return {
      type: createTargetGroupsByRegionConstants.CREATE_TARGET_GROUPS_BY_REGION_LOADING,
    };
  }
  function createTargetGroupsByRegionSuccess(data) {
    return {
      type: createTargetGroupsByRegionConstants.CREATE_TARGET_GROUPS_BY_REGION_SUCCESS,
      data,
    };
  }
  function createTargetGroupsByRegionFailure(error) {
    return {
      type: createTargetGroupsByRegionConstants.CREATE_TARGET_GROUPS_BY_REGION_FAILURE,
      error,
    };
  }
  return (dispatch) => {
    dispatch(createTargetGroupsByRegionLoad());
    return new Promise((resolve, reject) => {
      targetGroupsRegionService.createTargetGroupsByRegion(requestBody).then(
        (data) => {
          dispatch(createTargetGroupsByRegionSuccess(data));
          resolve(data);
        },
        (error) => {
          dispatch(createTargetGroupsByRegionFailure(error?.toString()));
          errorExtractor(error, reject);
        }
      );
    });
  };
}
function editTargetGroupsByRegion(requestBody, queryParams) {
  function editTargetGroupsByRegionLoad() {
    return {
      type: editTargetGroupsByRegionConstants.EDIT_TARGET_GROUPS_BY_REGION_LOADING,
    };
  }
  function editTargetGroupsByRegionSuccess(data) {
    return {
      type: editTargetGroupsByRegionConstants.EDIT_TARGET_GROUPS_BY_REGION_SUCCESS,
      data,
    };
  }
  function editTargetGroupsByRegionFailure(error) {
    return {
      type: editTargetGroupsByRegionConstants.EDIT_TARGET_GROUPS_BY_REGION_FAILURE,
      error,
    };
  }
  return (dispatch) => {
    dispatch(editTargetGroupsByRegionLoad());
    return new Promise((resolve, reject) => {
      targetGroupsRegionService
        .editTargetGroupsByRegion(requestBody, queryParams)
        .then(
          (data) => {
            dispatch(editTargetGroupsByRegionSuccess(data));
            resolve(data);
          },
          (error) => {
            dispatch(editTargetGroupsByRegionFailure(error?.toString()));
            errorExtractor(error, reject);
          }
        );
    });
  };
}

function addTargetGroupsByRegion(requestBody, queryParams) {
  function addTargetGroupsByRegionLoad() {
    return {
      type: addTargetGroupsByRegionConstants.ADD_TARGET_GROUPS_BY_REGION_LOADING,
    };
  }
  function addTargetGroupsByRegionSuccess(data) {
    return {
      type: addTargetGroupsByRegionConstants.ADD_TARGET_GROUPS_BY_REGION_SUCCESS,
      data,
    };
  }
  function addTargetGroupsByRegionFailure(error) {
    return {
      type: addTargetGroupsByRegionConstants.ADD_TARGET_GROUPS_BY_REGION_FAILURE,
      error,
    };
  }
  return (dispatch) => {
    dispatch(addTargetGroupsByRegionLoad());
    return new Promise((resolve, reject) => {
      targetGroupsRegionService
        .addTargetGroupsByRegion(requestBody, queryParams)
        .then(
          (data) => {
            dispatch(addTargetGroupsByRegionSuccess(data));
            resolve(data);
          },
          (error) => {
            dispatch(addTargetGroupsByRegionFailure(error?.toString()));
            errorExtractor(error, reject);
          }
        );
    });
  };
}

function removeTargetGroupsByRegion(queryParams) {
  function removeTargetGroupsByRegionLoad() {
    return {
      type: removeTargetGroupsByRegionConstants.REMOVE_TARGET_GROUPS_BY_REGION_LOADING,
    };
  }
  function removeTargetGroupsByRegionSuccess(data) {
    return {
      type: removeTargetGroupsByRegionConstants.REMOVE_TARGET_GROUPS_BY_REGION_SUCCESS,
      data,
    };
  }
  function removeTargetGroupsByRegionFailure(error) {
    return {
      type: removeTargetGroupsByRegionConstants.REMOVE_TARGET_GROUPS_BY_REGION_FAILURE,
      error,
    };
  }
  return (dispatch) => {
    dispatch(removeTargetGroupsByRegionLoad());
    return new Promise((resolve, reject) => {
      targetGroupsRegionService.removeTargetGroupsByRegion(queryParams).then(
        (data) => {
          dispatch(removeTargetGroupsByRegionSuccess(data));
          resolve(data);
        },
        (error) => {
          dispatch(removeTargetGroupsByRegionFailure(error?.toString()));
          errorExtractor(error, reject);
        }
      );
    });
  };
}

function deleteTargetGroupsByRegion(queryParams) {
  function deleteTargetGroupsByRegionLoad() {
    return {
      type: deleteTargetGroupsByRegionConstants.DELETE_TARGET_GROUPS_BY_REGION_LOADING,
    };
  }
  function deleteTargetGroupsByRegionSuccess(data) {
    return {
      type: deleteTargetGroupsByRegionConstants.DELETE_TARGET_GROUPS_BY_REGION_SUCCESS,
      data,
    };
  }
  function deleteTargetGroupsByRegionFailure(error) {
    return {
      type: deleteTargetGroupsByRegionConstants.DELETE_TARGET_GROUPS_BY_REGION_FAILURE,
      error,
    };
  }
  return (dispatch) => {
    dispatch(deleteTargetGroupsByRegionLoad());
    return new Promise((resolve, reject) => {
      targetGroupsRegionService.deleteTargetGroupsByRegion(queryParams).then(
        (data) => {
          dispatch(deleteTargetGroupsByRegionSuccess(data));
          resolve(data);
        },
        (error) => {
          dispatch(deleteTargetGroupsByRegionFailure(error?.toString()));
          errorExtractor(error, reject);
        }
      );
    });
  };
}

export const targetGroupsByRegionActions = {
  getTargetGroupsByRegion,
  createTargetGroupsByRegion,
  editTargetGroupsByRegion,
  addTargetGroupsByRegion,
  removeTargetGroupsByRegion,
  deleteTargetGroupsByRegion,
};
